import styled from "@emotion/styled"

export const BlockItemRichTextStyles = styled.div`
    height: 200px;
    background-color: white;
    margin-bottom: 20px;
`